import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import './ActivitiesPage.css';
import { getStoredData } from "../../json/fetchData.js";

// Lazy load components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));
const ProjectList = lazy(() => import("../../components/ProjectList/ProjectList.js"));

const ActivitiesPage = () => {
  const totalData = getStoredData();
  const { id } = useParams();
  const [activitiesData, setActivitiesData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivitiesData = async () => {
      try {
        const response = await fetch(`https://pranusha.vercel.app/activities/${id}`);
        const data = await response.json();
        console.log("Fetched activity data:", data);
        setActivitiesData(data);
      } catch (error) {
        console.error("Error fetching activity data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivitiesData();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!activitiesData) return <p>Activity not found.</p>;

  return (
    <div>
      <Suspense fallback={<p>Loading header...</p>}>
        <AllIntroTemplate 
          image={activitiesData.photo?.[0]?.url || ""} 
          title={activitiesData.title || "No Title"} 
          page={totalData?.[0] || {}} 
        />
      </Suspense>

      <Suspense fallback={<p>Loading content...</p>}>
        <ContentModel data={activitiesData} />
      </Suspense>

      <Suspense fallback={<p>Loading related projects...</p>}>
        <ProjectList />
      </Suspense>
    </div>
  );
};

export default ActivitiesPage;
